import { type TipoDomandaDTO } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTO.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { CountdownHumanized } from '@framework/ui/components/display/countdown/CountdownHumanized.tsx';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { InquiryTypeStateTag } from '../../state/InquiryTypeStateTag.tsx';
import { InquiryCategoryRender } from './InquiryCategoryRender.tsx';
import { InquiryItemDivider } from './InquiryItemDivider.tsx';
import { InquiryRecipientTypeRender } from './InquiryRecipientTypeRender.tsx';

const ListItemButtonRow = styled.div`
  padding-top: 12px;
`;
const ListItemStateRow = styled.div`
  padding-bottom: 12px;
`;

export interface IInquiryItemBaseProps {
  inquiry?: TipoDomandaDTO;
  children?: React.ReactNode;
}

export function InquiryItemBase(props: IInquiryItemBaseProps) {
  const { inquiry, children } = props;

  const isMobile = useBreakpoint(down('sm'));

  const { t } = useTranslation();

  if (!inquiry) return null;

  return (
    <div key={inquiry.id}>
      {isMobile && <InquiryItemDivider />}
      {/* <VerticalSpace /> */}
      <ListItemStateRow>
        <InquiryTypeStateTag inquiry={inquiry} />
        {inquiry.dataFine && (
          <>
            {t('domanda.copertina.scadenza', 'Scadenza')}:{' '}
            <ISODate date={inquiry.dataFine} />
          </>
        )}
      </ListItemStateRow>
      <InquiryRecipientTypeRender recipients={inquiry.tipiUtenteCardinalita} />
      <InquiryCategoryRender categories={inquiry.categorie} />
      {inquiry.flMostraCountdown && (
        <CountdownHumanized expireDate={inquiry.dataFine} />
      )}
      <ListItemButtonRow>{children}</ListItemButtonRow>
    </div>
  );
}
